import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Button, Card, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { getFromStorage } from '../../utils/storage'
import { DOMAIN, api } from '../../utils/api'
import { handleError } from '../../utils/error'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions } from '../../redux/store'
import { mainGreen } from '../../utils/color'

export default function EditUser() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const { userId } = useParams()
	const [user, setUser] = useState()
	const [roleId, setRoleId] = useState('')
	const [roles, setRoles] = useState([])
	const [stores, setStores] = useState([])
	const [storeId, setStoreId] = useState('')
	const [showStore, setShowStore] = useState(false)

	const handleChangeSelectRole = (event) => {
		if (
			event.target.value !== '643cef2e162c633b558c08cd' &&
			event.target.value !== '643ce869e6c312b8c449e26f' &&
			event.target.value !== '643eaa0fd418d1fe9aefd4a7'
		) {
			setShowStore(true)
		} else {
			setShowStore(false)
		}
		setRoleId(event.target.value)
	}

	const handleChangeSelectStore = (event) => {
		setStoreId(event.target.value)
	}

	const getUser = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/admin/user/${userId}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setRoleId(response.data.role._id)
				if (
					response.data.store &&
					response.data.role._id !== '643cef2e162c633b558c08cd' &&
					response.data.role._id !== '643ce869e6c312b8c449e26f' &&
					response.data.role._id !== '643eaa0fd418d1fe9aefd4a7'
				) {
					setStoreId(response.data.store._id)
					setShowStore(true)
				}
				setUser(response.data)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, userId, navigate, dispatch],
	)

	const getRoles = useCallback(
		async function () {
			try {
				const response = await axios({
					url: currentUser.role === 'admin' ? api.GET_ROLES_ADMIN : api.GET_ROLES_DIRECTOR,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setRoles(response.data)
				getUser()
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, currentUser.role, getUser],
	)

	useEffect(() => {
		getRoles()
	}, [getRoles])

	const getStores = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_STORES_ADMIN,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setStores(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token],
	)

	useEffect(() => {
		getStores()
	}, [getStores])

	const editUser = async function () {
		try {
			const response = await axios({
				url: `${DOMAIN}/admin/edit-user/${userId}`,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'PUT',
				data: { roleId, storeId },
				withCredentials: true,
			})
			if (response.status === 200) {
				alert(response.data.message)
			}
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	return (
		<UserLayout>
			<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
				<Card
					sx={{
						margin: '20px 20px 10px 20px',
						padding: '10px',
					}}>
					<Typography sx={{ mb: 2 }}>Tên: {user?.name}</Typography>
					<Typography sx={{ mb: 2 }}>Email: {user?.email}</Typography>
					<FormControl sx={{ mt: 1, mr: 2, minWidth: 120 }} size='small'>
						<InputLabel id='role-select-small-label'>Vị trí</InputLabel>
						<Select
							required
							labelId='role-select-small-label'
							id='demo-select-small'
							label='Vị trí'
							value={roleId}
							onChange={handleChangeSelectRole}>
							{roles?.map((role, index) => {
								return (
									<MenuItem key={index} value={role._id}>
										{role.description}
									</MenuItem>
								)
							})}
						</Select>
					</FormControl>
					{showStore && (
						<FormControl sx={{ mt: 1, minWidth: 120 }} size='small'>
							<InputLabel id='role-select-small-label'>Cửa hàng</InputLabel>
							<Select
								required
								labelId='role-select-small-label'
								id='demo-select-small'
								label='Cửa hàng'
								value={storeId}
								onChange={handleChangeSelectStore}>
								{stores?.map((store, index) => {
									return (
										<MenuItem key={index} value={store._id}>
											{store.name}
										</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					)}
					<Box sx={{ mt: 2 }}>
						<Button
							sx={{
								marginLeft: 'auto',
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							fullWidth
							size='small'
							variant='contained'
							onClick={() => {
								const confirmEdit = window.confirm('Bạn có chắc muốn cập nhật vị trí làm việc người dùng này?')
								if (confirmEdit) {
									editUser()
									navigate('/admin/users')
								}
							}}>
							Cập nhật
						</Button>
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
